import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LineGraphReadingsDataDto } from '../../../data/models/line-graph-data-dto';
import { LineGraphSimpleDataDto } from '../../../data/models/line-graph-simple-data-dto';
import { LineGraphService } from '../../../services/line-graph.service';
import ApexCharts from 'apexcharts';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-line-traffic-digest-graph',
  templateUrl: './line-traffic-digest-graph.component.html',
  styleUrls: ['./line-traffic-digest-graph.component.scss'],
  providers: [MessageService]
})
export class LineTrafficDigestGraphComponent {
  @Input() lineId: number;
  @Input() isMonitored: boolean;

  mainResultList: LineGraphReadingsDataDto;
  resultList: LineGraphReadingsDataDto;
  readingList: LineGraphReadingsDataDto;

  chart: any = {};
  chartOptions: any;
  inTraffic: any[] = [];
  outTraffic: any[] = [];
  readingsTime: any[] = [];
  blockUI: boolean = false;
  loader: boolean = true;
  changesSubscriber: Subscription;

  constructor(private graphService: LineGraphService, private messageService: MessageService, private accountLineChangesService: AccountLineSubjectService) { }

  ngOnInit() {
    //this.accountLineChangesObserver();
    //this.isMonitored ?
     // (this.lineId) ? this.getLineGraphListData(this.lineId) : this.loader = false
      //: this.drawChart(new LineGraphReadingsDataDto());
    //else
    //  this.loader = false;

  }
  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
    //Write your code here
    
    //this.isMonitored ?
    (this.lineId) ? this.getLineGraphListData(this.lineId) : this.loader = false
    //  : this.drawChart(new LineGraphReadingsDataDto());
  }   

  ///`LineDetails/get-line-graphs-readings/`
  getLineGraphListData(lineId) {
    //this.blockUI = true;
    this.loader = true;
    this.graphService.getLineGraphDigestData(lineId).subscribe((res: LineGraphReadingsDataDto) => {
      this.mainResultList = this.resultList = res;
      this.drawChart(res);

    }, (error) => {
      //this.blockUI = false;
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Get Graph List Data', detail: 'sorry could not return data of the graph now' })
    })
  }


  async drawChart(upDownData: LineGraphReadingsDataDto) {
    let x: any = this.GetTrafficData(upDownData);
    this.destroyChartEvent();
    this.chartOptions = {
      series: [{
        name: 'OutTraffic',
        data: x.__zone_symbol__value.outTraffic //this.outTraffic ////
      },
      {
        name: 'Intraffic',
        data: x.__zone_symbol__value.inTraffic //this.inTraffic //  //
      }],
      chart: {
        height: 200,
        type: "line",
        toolbar: {
          show: false,
        },
        plotOptions: {
          area: {
            fillTo: 'origin',
          }
        },
      },
      colors: ['#068DA9', 'lightgreen'],
      dataLabels: {
        enabled: false
      },
      //title: {
      //  text: 'Traffic(24H)',
      //},
      stroke: {
        //curve: 'smooth',
        width: 2,
      },
      tooltip: {
        x: {
          show: true,
          format: 'dd MMM yyyy  HH:mm',
          formatter: undefined,
        },
        y: {
          title: {
            formatter: function (value1, value2) {
              return;
            }
          }

        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        categories: x.__zone_symbol__value.readingTime, tooltip: {
          enabled: false // Disable the x-axis tooltip
        }
      },
      yaxis: {
        title: {
          text: 'Speed(per second)'
        },
        labels: {

          formatter: function (value, index) {
            var val = Math.abs(value);
            if (val >= 1000000000) {
              value = (value / 1000000000).toFixed(1) + " G";
            }
            else if (val >= 1000000) {
              value = (value / 1000000).toFixed(1) + " M";
            }
            else if (val >= 1000 && val < 1000000) {
              value = (value / 1000).toFixed(1) + " K";
            }

            else if (val < 1000 ) {
              value = value ;
            } 
            
            return value;
          }
        }
      },
      
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    
    this.chart = new ApexCharts(document.querySelector('#graph'), this.chartOptions);
    this.chart.render();
    this.loader = false;

    //this.blockUI = false;
  }



  async GetTrafficData(upDownData: LineGraphReadingsDataDto) {
    this.inTraffic = [];
    this.outTraffic = [];
    this.readingsTime = [];

    for (var i = 0; i < upDownData?.readings?.length; i++) {
      this.readingsTime.push((upDownData.readings[i].readingTime));
      this.inTraffic.push((upDownData.readings[i].inTraffic));
      this.outTraffic.push((upDownData.readings[i].outTraffic));
    }
    if (upDownData == null || upDownData.readings == null ||  upDownData?.readings?.length == 0) {
      this.inTraffic.push[0];
      this.outTraffic.push[0];
//      this.readingsTime.push(this.toDate);

    }
    let inOutData = { inTraffic: this.inTraffic, outTraffic: this.outTraffic, readingTime: this.readingsTime };
    return inOutData;
  }


  destroyChartEvent() {

    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }

  }


  //accountLineChangesObserver() {
  //  this.changesSubscriber =this.accountLineChangesService.notifyChangesInSelectedLine.subscribe((res: LineDetailsDto) => {
  //    if (res) {
  //      this.lineId = res.id;
  //      //get data again
  //      this.lineId = res.id;
  //      this.getLineGraphListData(res.id);
  //    }
  //    //this.loader = false;
  //  }, (error) => {
  //    //this.loader = false;
  //    this.messageService.add({ severity: 'error', summary: 'Account Line Changes Observer', detail: 'Could not retrieve line Sammry data' });
  //  })
  //}

  ngOnDestroy() {
    //this.changesSubscriber.unsubscribe();

  }
}
